import ListController from './ListController'
export { ListController }
export default ListController



// WEBPACK FOOTER //
// ./src/components/ListController/index.js